import { CP_GET_LIST, CP_SET_CORREDOR_POLIZAS, startType } from '../constants/action-types';
import { DEFAULT_PAGE_SIZE } from '../../CONST';


const initialState = {
  list: {
    creditPolicies: {
      data: [],
      pages: 0,
      count: 0,
      next: '',
      previous: '',
    },
    corredorPolizas: [],
  },
  loading: false,
};

const setCorredorPolizas = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    corredorPolizas: action.payload,
  },
});

const initLoading = state => ({
  ...state,
  loading: true,
});

const getList = (state, action) => ({
  ...state,
  loading: false,
  list: {
    ...state.list,
    creditPolicies: {
      ...state.list.creditPolicies,
      data: action.payload.results,
      pages: Math.ceil(action.payload.count / DEFAULT_PAGE_SIZE),
      count: action.payload.count,
      next: action.payload.next,
      previous: action.payload.previous,
    },
  },
});


function credito(state = initialState, action) {
  switch (action.type) {
    case startType(CP_GET_LIST):
      return initLoading(state);
    case CP_GET_LIST:
      return getList(state, action);
    case CP_SET_CORREDOR_POLIZAS:
      return setCorredorPolizas(state, action);
    default:
      return state;
  }
}

export default credito;
